var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tooltip',{attrs:{"effect":"dark","content":_vm.tips,"placement":"top"}},[_c('span',{staticClass:"icon-qa"})])}
var staticRenderFns = []

export { render, staticRenderFns }